"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleChange = exports.handleBlur = exports.handlePasswordIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _validators = _interopRequireDefault(require("../constants/validators"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setErrorState = function setErrorState(props, message) {
  var setError = props.setError,
      setErrorMessage = props.setErrorMessage,
      onError = props.onError;
  setError(message ? true : false);
  setErrorMessage(message);
  if (message && _.has(props, 'onError')) onError({
    error: true,
    message: message
  });
};

var handleValidation = function handleValidation(value, props) {
  var optional = props.optional,
      optionalTag = props.optionalTag,
      charLength = props.charLength,
      charLimit = props.charLimit,
      type = props.type;

  if (!optionalTag && !optional && _validators["default"].required(value)) {
    return setErrorState(props, "This field can't be blank");
  }

  if (charLength > charLimit) {
    return setErrorState(props, 'Too many characters');
  }

  if (type === 'email' && _validators["default"].email(value)) {
    return setErrorState(props, 'Invalid email address');
  }

  if (type === 'number' && _validators["default"].number(value)) {
    return setErrorState(props, 'Invalid number');
  }

  if (type === 'decimal' && _validators["default"].numberOrFloat(value)) {
    return setErrorState(props, 'Invalid number');
  }

  if (type === 'password' && _validators["default"].password(value)) {
    return setErrorState(props, 'Invalid password');
  }

  if (_.has(props, 'validate')) {
    var response = props.validate(value);

    if (_.has(response, 'errorMessage')) {
      return setErrorState(props, response.errorMessage);
    }
  }

  return setErrorState(props, null);
};

var handlePasswordIcon = function handlePasswordIcon(type, setType) {
  if (type === 'password') {
    return /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon-right far fa-eye",
      onClick: function onClick() {
        return setType('text');
      }
    });
  } else {
    return /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon-right far fa-eye-slash",
      onClick: function onClick() {
        return setType('password');
      }
    });
  }
};

exports.handlePasswordIcon = handlePasswordIcon;

var handleBlur = function handleBlur(event, props) {
  var value = event.target.value;
  handleValidation(value, props);
};

exports.handleBlur = handleBlur;

var handleChange = function handleChange(event, props) {
  var charLimit = props.charLimit,
      setCharLength = props.setCharLength;

  if (charLimit) {
    setCharLength(event.target.value.length);
  }

  if (_.has(props, 'validateOnChange') && props.validateOnChange === true) {
    var value = event.target.value;

    if (_.has(props, 'charLimit')) {
      handleValidation(value, _objectSpread(_objectSpread({}, props), {}, {
        charLength: value.length
      }));
    } else {
      handleValidation(value, props);
    }
  }

  props.onChange(event);
};

exports.handleChange = handleChange;